import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { PlatformGroupRoleDto } from 'projects/shared/src/lib/models/PlatformGroupRoleDto';
import { TenantDto, TenantGroupRoleDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
//import { PlatformGroupRoleService } from 'projects/shared/src/lib/services/platform-group-role.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'add-user-dialog',
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddUserDialogComponent implements OnInit {

  userForm!: FormGroup;
  titleAlert: string = 'This field is required';
  @Input() labelPosition!: 'before' | 'after';

  groupRoles:TenantGroupRoleDto[] = [];
  //subSquirrels:PlatformGroupRoleDto[] = [];

//  tenants:TenantDto[] = [];

  filter!: GenericFilter;

  _isadmin!:string;

  constructor(private formBuilder: FormBuilder,
     public _dialogRef: MatDialogRef<AddUserDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any, // flag: vorher kein User vorhanden (wird nicht verwendet)
      public translate: TranslateService,
      private notificationService: NotificationService,
      //private platformGroupRoleService: PlatformGroupRoleService,
      private tenantService: TenantService,
      private oauthService: OAuthServiceService) { }

  ngOnInit() {

    // this.tenantService.getTenants(new GenericFilter).subscribe({
    //   next:(tenants:TenantDto[]) => {
    //     this.tenants = tenants;
    //   }
    // });

    this.filter = new GenericFilter();
    // this.platformGroupRoleService.getPlatformGroupRoles(this.filter).subscribe({
    //   next:(groupRoleDtos:PlatformGroupRoleDto[]) => { 
    //     console.log(groupRoleDtos)
    //     this.groupRoles = groupRoleDtos
    //   }
    // })
//    this.platformGroupRoleService.getPlatformGroupRoles(this.filter).subscribe({
    this.tenantService.getTenantGroupRoles(this.tenantService.currentTenantName, this.filter).subscribe({
       next:(groupRoleDtos:any) => { 
        // console.log("------> tenantGroupRoles: ", groupRoleDtos)
        this.groupRoles = groupRoleDtos;
        // this.subSquirrels = groupRoleDtos.item2;
      }
    })
    this.createUserForm();
  }

  get admin(): string {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin' ) {
              this._isadmin = dbrole;
            }
          });
        }
      }
    });
    return this._isadmin;
  }

  createUserForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    let roles:TenantGroupRoleDto[] = [];
    this.userForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(emailregex)]],
      emailConfirmed: [false],
      userName: ['NOTCONFIRMED'],
      firstName:[null],
      lastName:[null],
      phoneNumber: [null],
      phonenumberConfirmed: [false],
    //  lockoutEnabled: [false],
      twoFactorEnabled: [false],
     // accessFailedCount: [0],
     // lockoutEnd: [null],
      userRoles:[roles],
      // tenant:[null],
    });

  }



  // setChangeValidate() {
  //   this.userForm.get('validate')?.valueChanges.subscribe(
  //     (validate: any) => {
  //       if (validate == '1') {
  //         this.userForm.get('name')?.setValidators([Validators.required, Validators.minLength(3)]);
  //         this.titleAlert = "You need to specify at least 3 characters";
  //       } else {
  //         this.userForm.get('name')?.setValidators(Validators.required);
  //       }
  //       this.userForm.get('name')?.updateValueAndValidity();
  //     }
  //   )
  // }

  // checkPassword(control: any) {
  //   let enteredPassword = control.value
  //   let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  //   return (!passwordCheck.test(enteredPassword) && enteredPassword) ? { 'requirements': true } : null;
  // }

  cancel() {
    this._dialogRef.close();
  }

  add() {
    if (this.userForm.valid) {
      //console.log("=========> user form value", this.userForm.value)
      let userData = {userDto: this.userForm.value};
      // let data = {userDto: this.userForm.value, subSquirrels: this.subSquirrels};
      // this._dialogRef.close(this.userForm.value);
      // if(!this.data)
        this._dialogRef.close(userData);
      // else
      //   this._dialogRef.close(true);
    }
    else{
      this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    }
  }

  getErrorEmail() {
    return this.userForm.get('email')?.hasError('required') ? `${this.translate.data["ERRORALERT"]}` :
      this.userForm.get('email')?.hasError('pattern') ? `${this.translate.data["INVALIDEMAIL"]}` :
        this.userForm.get('email')?.hasError('alreadyInUse') ? `${this.translate.data["ALREADYTAKENEMAIL"]}` : '';
  }

  // getErrorPassword() {
  //   return this.userForm.get('password')?.hasError('required') ? 'Field is required (at least eight characters, one uppercase letter and one number)' :
  //     this.userForm.get('password')?.hasError('requirements') ? 'Password needs to be at least eight characters, one uppercase letter and one number' : '';
  // }

  public errorHandling = (control: string, error: string) => {
    return this.userForm.controls[control].hasError(error);
  }

}

